export type ConnectionStatus = "connected" | "disconnected" | "connecting" | "unknown";

export const DISCONNECT_DEBOUNCE_TIME_MS = 5_000;

export const STATUS_STYLES = {
    connected: {
        backgroundColor: "color-mix(in srgb, var(--mantine-color-green-5), transparent 90%)",
        iconColor: "var(--mantine-color-green-4)",
        tooltip: "Expert Voice Link connected.",
    },
    disconnected: {
        backgroundColor: "color-mix(in srgb, var(--mantine-color-red-7), transparent 90%)",
        iconColor: "var(--mantine-color-red-4)",
        tooltip: "Expert Voice Link Disconnected. Please return to EVL tab and refresh.",
    },
    connecting: {
        backgroundColor: "color-mix(in srgb, var(--mantine-color-warning-7), transparent 85%)",
        iconColor: "var(--mantine-color-warning-4)",
        tooltip: "Expert Voice Link Connecting...",
    },
    unknown: {
        backgroundColor: "color-mix(in srgb, var(--mantine-color-red-7), transparent 90%)",
        iconColor: "var(--mantine-color-red-4)",
        tooltip: "Cannot determine whether Expert Voice Link is connected. Please return to EVL tab and refresh.",
    },
} as const satisfies Record<ConnectionStatus, { backgroundColor: string; iconColor: string; tooltip: string }>;
